import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LoginPage from './page/LoginPage/LoginPage'
import RegisterPage from './page/RegisterPage/RegisterPage';
import PolicyPage from './page/PolicyPage/PolicyPage';
import RestorePage from './page/RestorePage/RestorePage';
import AboutProduct from './page/AboutProduct/AboutProduct';
import Devices from './page/Devices';
import Imeis from './page/Imeis'; 
import Users from './page/Users';
import DeviceDetals from './components/DeviceDetals/DeviceDetals';
import Navbar from './components/UI/Navbar/Navbar';
import FooterNav from './components/UI/FooterNav/FooterNav';
import './App.css';
import React from 'react';

function App() {

  return (   
      <Router>
        <div className="App">
          <Navbar />
        <Routes>
          <Route exact path="/" element={<AboutProduct />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/privacy" element={<PolicyPage />} />
          <Route path="/restore" element={<RestorePage />} />
          <Route path="/devices"  element={<Devices />} />
          <Route path="/imeis"  element={<Imeis />} />
          <Route path="/users"  element={<Users />} />
          <Route path="/device/:id" element={<DeviceDetals />} />
        </Routes>
        <FooterNav />
        </div>
      </Router>
  );
};

export default App;
